<template lang="html">
	<div
		class="notification clearfix"
		:class="{
			'cl-danger': notification.type === 'error',
			'cl-info': notification.type === 'info',
			'cl-success': notification.type === 'success',
			'cl-warning': notification.type === 'warning',
		}"
	>
		<div class="icon-box f-l mr-3">
			<i class="fa" :class="`fa-${notification.icon || 'warning'}`"></i>
		</div>
		<div class="content-box f-l">
			<div class="top clearfix">
				<div class="title f-l">{{ notification.subject }}</div>
				<div class="date f-r">
					{{ moment(notification.notification_date).fromNow() }}
				</div>
			</div>
			<div class="bottom clearfix">
				<div class="txt">{{ notification.notification }}</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		notification: {
			default: function () {
				return {
					subject: '',
					notification: '',
					notification_date: '',
					icon: '',
					type: '',
				};
			},
		},
	},
	data() {
		return {
			utils,
			moment,
		};
	},
};
</script>

<style lang="less">
@grey: #a7abbd;

.notification {
	padding: 22px 0;
	border-bottom: solid 1px #f5f9fb;
	cursor: pointer;

	.content-box {
		width: calc(100% - 65px);

		.title {
			color: #3d4661;
			font-weight: 600;
			font-size: 16px;
		}
		.txt {
			color: #646f79;
			font-size: 14px;
		}
		.date {
			color: #646f79;
			font-size: 13px;
			font-weight: 600;
		}
	}
	.icon-box {
		width: 50px;
		height: 50px;
		border-radius: 50%;
		text-align: center;
		background: #3d4661;
		color: var(--white);
		margin: 0 15px 0 0;

		i {
			font-size: 24px;
			padding: 12px 0;
		}
	}
}

.notification.cl-info {
	.icon-box {
		background: #3d4661;
	}
}
.notification.cl-success {
	.icon-box {
		background: #1ebe9c;
	}
}
.notification.cl-danger {
	.icon-box {
		background: var(--ne-red);
	}
}
.notification.cl-warning {
	.icon-box {
		background: #f2d309;
		color: #2e3549;
	}
}
</style>
